import React from 'react';
import PaintIcon from 'pubweb-react-components/dist/components/Icons/PaintIcon';
import Helmet from 'react-helmet';

import LandingHeader from '../components/LandingHeader/LandingHeader';

import '../styles/index.scss';

import SubpageContainer from '../styles/SubpageStyles';
import SubpageBody from "../components/SubpageBody/SubpageBody";
import SubpageFooter from "../components/SubpageFooter/SubpageFooter";

import { onHelmetChangeClientState } from '../utils/Analytics';
import { SubpageBackgroundImages } from "../utils/ImageSets";
import ScriptTags from '../components/ScriptTags';

import ImageSet from '../utils/ImageSets';

import mobileStyle from '../images/mobile/subpages-style-mobile.jpg';
import tabletStyle from '../images/tablet/subpages-style-tablet.jpg';
import desktopStyle from '../images/desktop/subpages-style-header.jpg';


const Style = () => {

    var backgroundImages = new ImageSet(mobileStyle, tabletStyle, desktopStyle);

    return (
        <SubpageContainer backgroundImages={backgroundImages}>
            <LandingHeader />
            <SubpageBody
                category='style'
                headerText='Style'
                formHeading="From shiplap accents to added functional storage, you can customize your dream home to be everything you've ever wanted."
                subHeaderText='Clayton Built&#174; Homes: Designed to Impress'
                backgroundImages={backgroundImages}>
                <div className="movin-header">
                    <PaintIcon />
                    <h3>Get the style you want at a price you&rsquo;ll love.</h3>
                </div>
                <div className="body-container">
                    <div className="body-column-left">Whether your style is modern, contemporary, French country or farmhouse, we&rsquo;ve got something for you! Our architects and home designers stay up-to-date on the latest interior home design trends so we can offer you countless home features and customization options to choose from that will fit your lifestyle and your budget. </div>
                    <div className="body-column-right">From shiplap accents to added functional storage, you can customize your dream home to be everything you&rsquo;ve ever wanted. Sign up to get our *free* Home Buyer&rsquo;s Guide to learn more about the style, quality and affordability of Clayton Built&#174; homes and receive more information from Clayton!</div>
                </div>
            </SubpageBody>
            <SubpageFooter
                linkNext="/affordability"
                linkPrev="/quality"
                textNext="Affordability"
                textPrev="Quality"
            />
            <ScriptTags />

            <Helmet
                onChangeClientState={onHelmetChangeClientState}
                script={[
                    {
                        type: 'text/javascript',
                        innerHTML: `
                        if (typeof fbq !== 'undefined'){
                            fbq('track', 'PageView');
                        }
                        if (typeof gtag !== 'undefined'){
                            gtag('event', 'page_view', {'send_to': 'AW-1040796449','dynx_itemid': 'HIM2018','dynx_pagetype': 'Style'});
                            gtag('event', 'conversion', {
                                'allow_custom_scripts': true,
                                'send_to': 'DC-6346097/fall1003/fall10+standard'
                        });
    
                    }
                `
                    }
                ]}
            >
                <title>Have It Made | Style | Clayton Homes</title>
            </Helmet>
        </SubpageContainer>
    );
}

export default Style;



// WEBPACK FOOTER //
// ./src/pages/style.js